"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _time = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/time.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _time.default);

var TimeItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TimeItem, _Component);

  var _super = _createSuper(TimeItem);

  function TimeItem(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimeItem);
    _this = _super.call(this, props);

    _this._onDown = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          max = _this$props.max,
          name = _this$props.name,
          time = _this$props.time,
          format12Hours = _this$props.format12Hours;
      var aux; //find the min value

      if (format12Hours && name === 'hour') {
        //for 12h clock we are skipping to display 00 value
        aux = 1;
      } else {
        //for 24h clock we are displaying 00 value
        aux = 0;
      }

      var maxAux = _this.setMax(name, max);

      if (name !== 'meridiem' & !isNaN(value) && (0, _parseInt2.default)(value, 10) < maxAux) {
        aux = (0, _parseInt2.default)(value, 10) + 1;
      } else if (value === maxAux) {
        _this.increaseTimeObj(name, time, format12Hours);
      } else if (name === 'meridiem') {
        var _context;

        aux = (0, _indexOf.default)(_context = _this.CLOCK).call(_context, value) ? 0 : 1;

        _this.props.updateActiveColumn();
      }

      if (format12Hours && name === 'hour' && aux === 12) {
        var newMeridiem = time.meridiem ? 0 : 1;

        _this.props.updateTime(newMeridiem, 'meridiem');
      }

      _this.props.updateTime(aux, name);
    };

    _this.increaseTimeObj = function (name, time, format12Hours) {
      if (name === 'second' && (0, _parseInt2.default)(time.minute, 10) < 60) {
        var newMinute = (0, _parseInt2.default)(time.minute, 10) + 1;
        var newHour;

        if (newMinute === 60) {
          newMinute = 0;
          newHour = (0, _parseInt2.default)(time.hour, 10) + 1;

          _this.increaseHour(format12Hours, newHour, time);
        }

        _this.props.updateTime(newMinute, 'minute');
      }

      if (name === 'minute') {
        var _newHour = (0, _parseInt2.default)(time.hour, 10) + 1;

        _this.increaseHour(format12Hours, _newHour, time);
      }

      if (name === 'hour' && !format12Hours) {
        var _newHour2 = 0;

        _this.props.updateTime(_newHour2, 'hour');
      }
    };

    _this.increaseHour = function (format12Hours, newHour, time) {
      if (format12Hours && newHour < 12) {
        newHour = 1;

        _this.props.updateTime(newHour, 'hour');
      } else if (format12Hours && newHour === 12) {
        _this.props.updateTime(newHour, 'hour');

        var newMeridiem = time.meridiem ? 0 : 1;

        _this.props.updateTime(newMeridiem, 'meridiem');
      } else if (format12Hours && newHour <= 12 || !format12Hours && newHour < 24) {
        _this.props.updateTime(newHour, 'hour');
      } //if hour value to max value (24) then reset to 0 because we are not displaying value 24


      if (!format12Hours && newHour >= 24) {
        newHour = 0;

        _this.props.updateTime(newHour, 'hour');
      }
    };

    _this.decreaseTimeObj = function (name, time) {
      if (name === 'second') {
        var newMinute = (0, _parseInt2.default)(time.minute, 10) - 1;

        if ((0, _parseInt2.default)(time.minute, 10) === 0) {
          newMinute = 59;
        }

        _this.props.updateTime(newMinute, 'minute');

        if (newMinute === 59) {
          var newHour = (0, _parseInt2.default)(time.hour, 10) - 1;

          if (newHour === 0 && _this.props.format12Hours) {
            newHour = 12;
          } else if (newHour < 0 && !_this.props.format12Hours) {
            newHour = 23;
          } else if (newHour === 11 && _this.props.format12Hours) {
            var newMeridiem = time.meridiem ? 0 : 1;

            _this.props.updateTime(newMeridiem, 'meridiem');
          }

          _this.props.updateTime(newHour, 'hour');
        }
      }

      if (name === 'minute' && (0, _parseInt2.default)(time.hour, 10) > 0) {
        var _newHour3 = (0, _parseInt2.default)(time.hour, 10) - 1;

        if (_newHour3 === 0 && _this.props.format12Hours) {
          _newHour3 = 12; //change meridiem
        } else if (_newHour3 === 11 && _this.props.format12Hours) {
          var _newMeridiem = time.meridiem ? 0 : 1;

          _this.props.updateTime(_newMeridiem, 'meridiem');
        }

        _this.props.updateTime(_newHour3, 'hour');
      }
    };

    _this._onUp = function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          max = _this$props2.max,
          name = _this$props2.name,
          time = _this$props2.time,
          format12Hours = _this$props2.format12Hours;

      var aux = _this.setMax(name, max);

      if (name !== 'meridiem' && !isNaN(value) && (0, _parseInt2.default)(value, 10) > 0 && value <= (0, _parseInt2.default)(max, 10)) {
        aux = (0, _parseInt2.default)(value, 10) - 1;

        if (aux === 0 && name === 'hour' && format12Hours) {
          aux = max;
        }
      } else if (name === 'meridiem') {
        var _context2;

        aux = (0, _indexOf.default)(_context2 = _this.CLOCK).call(_context2, value) ? 0 : 1;
      } else if (value === 0) {
        _this.decreaseTimeObj(name, time);
      }

      if (name === 'hour' && aux === 11 && format12Hours) {
        var newMeridiem = time.meridiem ? 0 : 1;

        _this.props.updateTime(newMeridiem, 'meridiem');
      }

      _this.props.updateTime(aux, name);
    };

    _this.setMax = function (name, max) {
      var maxAux;

      if (name === 'hour' && _this.props.format12Hours) {
        maxAux = (0, _parseInt2.default)(max, 10);
      } else {
        maxAux = (0, _parseInt2.default)(max, 10) - 1;
      }

      return maxAux;
    };

    _this.onClick = function (selectedValue) {
      _this.setState({
        value: selectedValue
      });

      _this.props.updateTime(selectedValue, _this.props.name);

      _this.props.name === 'meridiem' && _this.props.updateActiveColumn();
    };

    _this.getDisplayValue = function (value) {
      return (0, _parseInt2.default)(value, 10) < 10 ? '0' + (0, _parseInt2.default)(value, 10) : value;
    };

    _this.generateValues = function () {
      var _this$props3 = _this.props,
          name = _this$props3.name,
          max = _this$props3.max,
          format12Hours = _this$props3.format12Hours,
          placeholder = _this$props3.placeholder,
          value = _this$props3.value,
          disabled = _this$props3.disabled,
          inputProps = _this$props3.inputProps,
          cssNamespace = _this$props3.cssNamespace;

      if (name === 'meridiem') {
        var _context3;

        return (0, _map.default)(_context3 = _this.CLOCK).call(_context3, function (amPmValue, index) {
          return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, inputProps, {
            className: classnames("".concat(cssNamespace, "-time__item")),
            key: index,
            onClick: function onClick() {
              return _this.onClick(index);
            }
          }), index === 0 && /*#__PURE__*/_react.default.createElement("div", {
            className: classnames("".concat(cssNamespace, "-time__current-indicator"))
          }), /*#__PURE__*/_react.default.createElement("span", {
            className: classnames("".concat(cssNamespace, "-time__unit"))
          }, amPmValue));
        });
      }

      var values = [];
      var before;
      var after;
      var center = value !== null ? (0, _parseInt2.default)(value, 10) : placeholder;
      var intMax = (0, _parseInt2.default)(max, 10);
      var is24HourTime = name === 'hour' && !format12Hours;

      if (center < 4) {
        before = center + intMax - 3;

        if (before === 60 || is24HourTime && before === 24) {
          before = 0;
        }
      } else {
        before = center - 3;
      }

      for (var i = 0; i < 3; i++) {
        values.push(before);
        before + 1 > intMax ? before = 1 : before += 1;

        if (before === 60 || is24HourTime && before === 24) {
          before = 0;
        }
      }

      values.push(center);

      if (name === 'hour') {
        if (format12Hours && center === 12) {
          after = 1;
        } else if (!format12Hours && center === 23) {
          after = 0;
        } else {
          after = center + 1;
        }
      } else if (center === 59) {
        after = 0;
      } else {
        after = center + 1;
      }

      for (var _i = 0; _i < 3; _i++) {
        values.push(after);
        after += 1;

        if (after === 60 || is24HourTime && after === 24) {
          after = 0;
        }
      }

      return (0, _map.default)(values).call(values, function (timeValue, i) {
        return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, inputProps, {
          className: classnames("".concat(cssNamespace, "-time__item")),
          key: i,
          onClick: disabled ? null : function () {
            return _this.onClick(timeValue);
          }
        }), i === 0 && /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssNamespace, "-time__current-indicator"))
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: classnames("".concat(cssNamespace, "-time__unit"))
        }, _this.getDisplayValue(timeValue)));
      });
    };

    _this.CLOCK = [_this.props.localizedText.meridiemAM, _this.props.localizedText.meridiemPM];
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  (0, _createClass2.default)(TimeItem, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props4 = this.props,
          disabled = _this$props4.disabled,
          upButtonProps = _this$props4.upButtonProps,
          downButtonProps = _this$props4.downButtonProps,
          value = _this$props4.value,
          active = _this$props4.active,
          localizedText = _this$props4.localizedText,
          name = _this$props4.name,
          cssNamespace = _this$props4.cssNamespace;
      var isActive = active === name;
      var wrapperClasses = classnames("".concat(cssNamespace, "-time__wrapper"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-time__wrapper--active"), isActive), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-time__wrapper--meridian"), this.props.name === 'meridiem'), _classnames));
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, upButtonProps, {
        "aria-label": localizedText.buttonUp,
        disabled: disabled,
        glyph: "navigation-up-arrow",
        onClick: this._onUp,
        option: "transparent"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: wrapperClasses
      }, !isActive ? /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(cssNamespace, "-time__item"), "".concat(cssNamespace, "-time__item--collapsed")),
        onClick: name === 'meridiem' ? this.props.onCollapsedClick : null
      }, this.getDisplayValue(value)) : /*#__PURE__*/_react.default.createElement("ul", {
        className: classnames("".concat(cssNamespace, "-time__list"))
      }, this.generateValues())), /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, downButtonProps, {
        "aria-label": localizedText.buttonDown,
        disabled: disabled,
        glyph: "navigation-down-arrow",
        onClick: this._onDown,
        option: "transparent"
      })));
    }
  }]);
  return TimeItem;
}(_react.Component);

TimeItem.displayName = 'TimeItem';
process.env.NODE_ENV !== "production" ? TimeItem.propTypes = {
  localizedText: _propTypes.default.object.isRequired,
  active: _propTypes.default.string,
  arialabel: _propTypes.default.string,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Internal use only */
  downButtonProps: _propTypes.default.object,
  format12Hours: _propTypes.default.bool,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,
  max: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  name: _propTypes.default.string,

  /** Localized placeholder text of the input */
  placeholder: _propTypes.default.string,
  time: _propTypes.default.object,
  upButtonProps: _propTypes.default.object,

  /* Internal use only */
  updateActiveColumn: _propTypes.default.func,
  updateTime: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /* Internal use only */
  onCollapsedClick: _propTypes.default.func
} : void 0;
TimeItem.defaultProps = {
  updateTime: function updateTime() {}
};

var _default = (0, _withStyles.default)(TimeItem);

exports.default = _default;